export const DEFAULT_PAGE_VIEWS = 0;
export const PAGE_VIEW_COOKIE_NAME = 'page_views';
export const CURRENT_SESSION_URL_KEY = 'user_session.current_session_url';
export const DOMAIN_NAME = 'fiverr.com';
export const COOKIE_PATH = '/';
